import React from "react";
import Svg from "@/Components/Svg";
import {useModalStore} from "@/Stores/Site/ModalStore";
import AskQuestionFormModal from "@/Components/Modal/AskQuestionFormModal";
import "@/Scss/Components/askQuestion.scss";

const AskQuestion = (props) => {
    const openModalAskQuestion = useModalStore(state => state.openModalAskQuestion);

    return (
        <div className={`askQuestion`}>
            <div className={`askQuestion__icon`}>
                <Svg id={`sendEmail`} className={`svg--sendEmail`} />
            </div>
            <p className={`askQuestion__subtitle`}>
                Нужна консультация?
            </p>
            <p className={`askQuestion__description`}>
                Напишите нам!
            </p>
            <div className={`button button--white`} onClick={openModalAskQuestion}>
                Задать вопрос
            </div>
            <AskQuestionFormModal {...props} />
        </div>
    );
}

export default AskQuestion;
